import { TripStatusNotification } from './components/TripStatusNotification';
import type { NotificationMetaDataCallback } from './types';

export const FacilityTripAcceptedRenderer = TripStatusNotification;

export const getMetaData: NotificationMetaDataCallback = (_notification) => {
  return {
    title: 'Trip Accepted (Facility Portal)',
  };
};
